import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=781063fc&"
import script from "./DateInput.vue?vue&type=script&lang=ts&"
export * from "./DateInput.vue?vue&type=script&lang=ts&"
import style0 from "./DateInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781063fc')) {
      api.createRecord('781063fc', component.options)
    } else {
      api.reload('781063fc', component.options)
    }
    module.hot.accept("./DateInput.vue?vue&type=template&id=781063fc&", function () {
      api.rerender('781063fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/DateInput.vue"
export default component.exports